import { StoreContext } from '@roc/feature-app-core';
import { useContext } from 'react';
import { BorrowerLoanApplicationsStore } from '../stores/borrowerLoanApplicationsStore';

export const useBorrowerLoanApplicationsStore = () =>
  useContext<{
    borrowerLoanApplicationsStore: BorrowerLoanApplicationsStore;
  }>(StoreContext);
